import Hero from './Hero';
import Features from './Features';
import HowItWorks from './HowItWorks';
import Web3Banner from './Web3Banner';
import FAQ from './FAQ';

export default function Instagram() {
  return (
    <>
      <Hero />
      <Features />
      <HowItWorks />
      <Web3Banner />
      <FAQ />
    </>
  );
}